<template>
  <div>
    <div class="px-md-6 px-sm-4 px-1">
      <div class="d-block d-sm-none">
        <div class="mobile-lottery-icon-group">
          <div
            class="single-group"
            :class="selectedTab == 'all' ? 'selected' : ''"
            @click="selectedTab = 'all'"
          >
            <fdsvg class="mobile-footer-svg"></fdsvg>
          </div>
          <div
            class="single-group"
            :class="selectedTab == 'west' ? 'selected' : ''"
            @click="selectedTab = 'west'"
          >
            <img src="/images/jackpot/1-02.png" alt="" />
          </div>
          <div
            class="single-group"
            :class="selectedTab == 'east' ? 'selected' : ''"
            @click="selectedTab = 'east'"
          >
            <img src="/images/jackpot/2-02.png" alt="" />
          </div>
          <div
            class="single-group"
            :class="selectedTab == 'other' ? 'selected' : ''"
            @click="selectedTab = 'other'"
          >
            <img src="/images/jackpot/3-02.png" alt="" />
          </div>
          <div
            class="single-group"
            :class="selectedTab == 'jackpot' ? 'selected' : ''"
            @click="selectedTab = 'jackpot'"
          >
            <img src="/images/jackpot/4-02.png" alt="" />
          </div>
          <div class="single-group" @click="openLotterySepcialDrawDialog">
            <img src="/images/jackpot/5-02.png" alt="" />
          </div>
          <!--<div class="single-group" @click="openLotteryPrizeDialog">
            <img src="/images/jackpot/6-02.png" alt="" />
          </div>-->
        </div>

        <div v-if="selectedTab == 'west' || selectedTab == 'all'">
          <v-card class="pa-4" color="#13192d">
            <app-magnum :mktData="magnumData"></app-magnum>
          </v-card>
          <v-card class="pa-4" color="#13192d">
            <app-damacai :mktData="damacaiData"></app-damacai>
          </v-card>
          <v-card class="pa-4" color="#13192d">
            <app-sports-toto :mktData="sportsTotoData"></app-sports-toto>
          </v-card>
          <v-card class="pa-4" color="#13192d">
            <app-singapore :mktData="singaporeData"></app-singapore>
          </v-card>
        </div>
        <div v-if="selectedTab == 'east' || selectedTab == 'all'">
          <v-card class="pa-4" color="#13192d">
            <app-sarawak :mktData="sarawakData"></app-sarawak>
          </v-card>
          <v-card class="pa-4" color="#13192d">
            <app-sabah :mktData="sabahData"></app-sabah>
          </v-card>
          <v-card class="pa-4" color="#13192d">
            <app-sandakan :mktData="sandakanData"></app-sandakan>
          </v-card>
        </div>
        <div v-if="selectedTab == 'other' || selectedTab == 'all'">
          <v-card class="pa-4" color="#13192d">
            <app-super-j-b-three-pm
              :mktData="jThreeAfternoonData"
            ></app-super-j-b-three-pm>
          </v-card>
          <v-card class="pa-4" color="#13192d">
            <app-super-j-b-nine-pm
              :mktData="jThreeNightData"
            ></app-super-j-b-nine-pm>
          </v-card>
          <v-card class="pa-4" color="#13192d">
            <app-grand-dragon :mktData="grandDragonData"></app-grand-dragon>
          </v-card>
        </div>

        <div v-if="selectedTab == 'jackpot' || selectedTab == 'all'">
          <v-card class="pa-4" color="#13192d">
            <app-sports-toto-six-d
              :mktSixDData="sportsTotoSixDData"
              :mktFiveDData="sportsTotoFiveDData"
              :mktStarTotoData="starTotoData"
              :mktPowerTotoData="powerTotoData"
            ></app-sports-toto-six-d>
          </v-card>
          <v-card class="pa-4" color="#13192d">
            <app-damacai-six-d :mktData="damacaiSixDData"></app-damacai-six-d>
          </v-card>
          <v-card class="pa-4" color="#13192d">
            <app-magnum-jackpot-gold
              :mktData="magnumJackpotGold[1]?.jpData"
            ></app-magnum-jackpot-gold>
          </v-card>
          <v-card class="pa-4" color="#13192d">
            <app-magnum-life
              :mktData="magnumJackpotGold[0]?.jpData"
            ></app-magnum-life>
          </v-card>
        </div>
      </div>
      <div class="d-none d-sm-block jackpot-detail-box black--text">
        <v-row justify="center">
          <v-col sm="12" lg="11">
            <v-row justify="center" no-gutters>
              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-magnum :mktData="magnumData"></app-magnum>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-damacai :mktData="damacaiData"></app-damacai>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-sports-toto :mktData="sportsTotoData"></app-sports-toto>
                </div>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-singapore :mktData="singaporeData"></app-singapore>
                </div>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-sarawak :mktData="sarawakData"></app-sarawak>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-sabah :mktData="sabahData"></app-sabah>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-sandakan :mktData="sandakanData"></app-sandakan>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-super-j-b-three-pm
                    :mktData="jThreeAfternoonData"
                  ></app-super-j-b-three-pm>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-super-j-b-nine-pm
                    :mktData="jThreeNightData"
                  ></app-super-j-b-nine-pm>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-grand-dragon
                    :mktData="grandDragonData"
                  ></app-grand-dragon>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-sports-toto-six-d
                    :mktSixDData="sportsTotoSixDData"
                    :mktFiveDData="sportsTotoFiveDData"
                    :mktStarTotoData="starTotoData"
                    :mktPowerTotoData="powerTotoData"
                  ></app-sports-toto-six-d>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-damacai-six-d
                    :mktData="damacaiSixDData"
                  ></app-damacai-six-d>
                </div>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-magnum-jackpot-gold
                    :mktData="magnumJackpotGold[1]?.jpData"
                  ></app-magnum-jackpot-gold>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="ma-3">
                  <app-magnum-life
                    :mktData="magnumJackpotGold[0]?.jpData"
                  ></app-magnum-life>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import AppMagnumJackpotGold from "@/components/mkt/MagnumJackpotGold.vue";
import AppMagnumLife from "@/components/mkt/MagnumLife.vue";
import AppMagnum from "@/components/mkt/Magnum.vue";
import AppDamacai from "@/components/mkt/Damacai.vue";
import AppSportsToto from "@/components/mkt/SportsToto.vue";
import AppGrandDragon from "@/components/mkt/GrandDragon.vue";
import AppSportsTotoSixD from "@/components/mkt/SportsTotoSixD.vue";
import AppDamacaiSixD from "@/components/mkt/DamacaiSixD.vue";
import AppSuperJBThreePm from "@/components/mkt/SuperJBThreePm.vue";
import AppSuperJBNinePm from "@/components/mkt/SuperJBNinePm.vue";
import AppSandakan from "@/components/mkt/Sandakan.vue";
import AppSabah from "@/components/mkt/Sabah.vue";
import AppSarawak from "@/components/mkt/Sarawak.vue";
import AppSingapore from "@/components/mkt/Singapore.vue";

import axios from "axios";
import fdsvg from "@/components/svg/4D.vue";

export default {
  components: {
    AppMagnum,
    AppDamacai,
    AppSportsToto,
    AppGrandDragon,
    AppSportsTotoSixD,
    AppDamacaiSixD,
    AppSuperJBThreePm,
    AppSuperJBNinePm,
    fdsvg,
    AppSandakan,
    AppSabah,
    AppSarawak,
    AppSingapore,
    AppMagnumJackpotGold,
    AppMagnumLife,
  },
  data: () => ({
    magnumData: {},
    damacaiData: {},
    sportsTotoData: {},
    singaporeData: {},
    grandDragonData: {},
    sandakanData: {},
    jThreeAfternoonData: {},
    jThreeNightData: {},
    sabahData: {},
    sarawakData: {},
    damacaiSixDData: {},
    sportsTotoSixDData: {},
    sportsTotoFiveDData: {},
    starTotoData: {},
    powerTotoData: {},
    magnumJackpotGold: [],
    selectedTab: "all",
    tab: 0,
  }),

  async mounted() {
    await this.getJackpot();
    this.runIntervalGetJackpot();
  },
  methods: {
    async getJackpot() {
      const response = await axios.get(
        "https://backoffice.luckypesta.net/api/webpagecontent/4d/mkt"
      );

      if (response.data.success) {
        let d = response.data;
        this.magnumData = d.data.m;
        this.damacaiData = d.data.d;
        this.sportsTotoData = d.data.t;
        this.singaporeData = d.data.singaporeToto;
        this.grandDragonData = d.data.g;
        this.sandakanData = d.data.sandakanToto;
        this.sabahData = d.data.sabahToto;
        this.sarawakData = d.data.sarawakToto;
        this.damacaiSixDData = d.data.d3;
        this.sportsTotoSixDData = d.data.supremeToto;
        this.sportsTotoFiveDData = d.data.t5;
        this.powerTotoData = d.data.powerToto;
        this.starTotoData = d.data.st;
        this.magnumJackpotGold = d.data.magnumLifeJackpot;
        this.jThreeAfternoonData = d.data.jThreeAfternoon;
        this.jThreeNightData = d.data.jThreeNight;
      }
    },
    runIntervalGetJackpot() {
      this.$options.refreshToTOJackpot = setInterval(this.getJackpot, 10000);
    },
    showData(value, append = "", prepend = "") {
      if (value == "" || value == undefined || value == null) {
        return "----";
      } else if (value.toString().includes("script")) {
        return `${append}${parseInt(
          value.toString().match(/\d+/)[0]
        )}${prepend}`;
      } else {
        return `${append}${value}${prepend}`;
      }
    },
    numberWithCommas(value) {
      if (value == "" || value == undefined || value == null) {
        return "----";
      } else {
        const number = parseFloat(value);
        const formattedNumber = number.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        return `RM ${formattedNumber}`;
      }
    },
    openLotterySepcialDrawDialog() {
      this.$root.$app.openLotterySpecialDrawDialog();
    },
    openLotteryPrizeDialog() {
      this.$root.$app.openLotteryPrizeDialog();
    },
  },
};
</script>

<style lang="scss">
.outerbox {
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  border: #b4b4b4 1px solid;
  vertical-align: top;
  -moz-box-shadow: 0 0 2px 1px #ddd;
  -webkit-box-shadow: 0 0 2px 1px #ddd;
  box-shadow: 0 0 2px 1px #ddd;

  background-color: #fff;
  text-align: center;
  padding: 5px;
}

.resultTable2 {
  width: 100%;
  margin: 3px 0;
  padding: 0;
}
.resultm4dlable {
  background-color: #ff0;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  color: #444;
  height: 26px;
}

.resultdamacailable {
  background-color: navy;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  height: 26px;
}

.resultgdlottolable {
  background-color: #e81409;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  height: 26px;
}

.resulttotolable {
  background-color: #ad0006;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  height: 26px;
}

.resultprizelable {
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  background-color: #333;
  color: #fff;
  min-height: 25px;
  vertical-align: middle;
  padding: 5px 0;
  border-color: #333;
  border-style: solid;
  border-width: 1px;
}

.resultdrawdate {
  text-align: left;
  font-size: 14px;
  color: #333;
  padding: 5px 0;
  vertical-align: middle;
}

.resultbottom {
  text-align: center;
  font-size: 24px;
  color: #000;
  width: 20%;
  border-color: #ccc;
  border-style: solid;
  border-width: 1px;
  padding: 3px 0;
  height: 36px;
}

.jackpot-detail-box {
  height: auto;
  position: relative;
  margin-top: 180px;
}

@media (max-width: 959px) {
  .jackpot-detail-box {
    margin-top: 190px;
  }
}
@media (max-width: 599px) {
  .jackpot-detail-box {
    margin-top: 150px;
  }
}

.resulttop {
  font-size: 28px;
  color: #303030;
  font-weight: 700;
  text-align: center;
  border-color: #ccc;
  border-style: solid;
  border-width: 1px;
  padding: 2px 0;
  height: 40px;
}

.mobile-lottery-icon-group {
  div.single-group {
    width: calc(100% / 6);
    display: inline-block;
    padding: 4px;
    position: relative;
    vertical-align: middle;
    text-align: center;
    border-bottom: 2px solid transparent;
    &.selected {
      border-bottom: 2px solid #e43bde;
    }

    img {
      width: 100%;
    }
  }
}

.mobile-footer-svg {
  width: 50px;
  height: auto;
  padding: 8px 0 0px;
}
</style>
